module.exports = __webpack_public_path__ + "img/cloud.dce7bf5.png";